import {
  ELEMENT_TYPE_DP_SUBJECT_STANDARD,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_DP_LEARNER_PROFILE,
  ELEMENT_TYPE_DP_SYLLABUS,
  ELEMENT_TYPE_MYP_OBJECTIVES,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_MYP_KEY_CONCEPT,
  ELEMENT_TYPE_MYP_RELATED_CONCEPT,
  ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT,
  ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_UBD_KEY_CONCEPT,
  ELEMENT_TYPE_UBD_FOCUS_AREA,
  ELEMENT_TYPE_UBD_LEARNER_PROFILE,
  ELEMENT_TYPE_UbD_THEME,
  PLANNER_ELEMENT_MYP_GLOBAL_CONTEXT,
  ELEMENT_TYPE_MYP_FOCUS_AREA,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_PYP_ACTION,
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_PYP_KEY_CONCEPT,
  ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
} from "Constants/stringConstants";

export const pypElementMapping = {
  lp: "LEARNER_PROFILE",
  concepts: "CONCEPT",
  theme: "THEME",
  atls: "ATL",
  centralIdea: "CI",
  lois: "LOI",
  inquiryQuestions: "INQUIRY_QUESTIONS",
  benchmarks: "BENCHMARK",
  action: "ACTION",
  unitPlan: "UNIT_PLAN",
  learningStandardUBD: "UBD_LEARNING_STANDARD",
  atlsUBD: "UBD_ATL",
  atlsMYP: "MYP_ATL",
  learningStandardMYP: "MYP_LEARNING_STANDARD",
  subjectStandardDP: ELEMENT_TYPE_DP_SUBJECT_STANDARD,
  atlDP: ELEMENT_TYPE_DP_ATL,
  learnerProfileDP: ELEMENT_TYPE_DP_LEARNER_PROFILE,
  syllabusContentDP: ELEMENT_TYPE_DP_SYLLABUS,
  objectivesMYP: ELEMENT_TYPE_MYP_OBJECTIVES,
  conceptsMYP: ELEMENT_TYPE_MYP_KEY_CONCEPT,
  relatedConceptsMYP: ELEMENT_TYPE_MYP_RELATED_CONCEPT,
  specifiedConcepts: ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT,
  lpMYP: ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  aimDP: "DP_AIM",
  objectivesDP: "DP_OBJECTIVES",
  interdisciplinaryCriteriaMYP: ELEMENT_TYPE_MYP_OBJECTIVES,
};

// when only subject is selected (without strand, sub-strand etc.) in evaluation criteria
// then ratingLevels for subject standards in org constants will have these as ibPYPElementValue
export const pypElementSubjectStandardsMapping = {
  learningStandardUBD: "UBD_SUBJECT",
  learningStandardMYP: "MYP_SUBJECT",
  subjectStandardDP: "DP_SUBJECT",
};

export const plannerElementFieldUidMap = {
  learningStandardUBD: ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  atlsUBD: ELEMENT_TYPE_UBD_ATL,
  conceptsUBD: ELEMENT_TYPE_UBD_KEY_CONCEPT,
  focusAreasUBD: ELEMENT_TYPE_UBD_FOCUS_AREA,
  lpUBD: ELEMENT_TYPE_UBD_LEARNER_PROFILE,
  themeUBD: ELEMENT_TYPE_UbD_THEME,
  relatedConceptsMYP: ELEMENT_TYPE_MYP_RELATED_CONCEPT,
  specifiedConcepts: ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT,
  learningStandardMYP: ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  atlsMYP: ELEMENT_TYPE_MYP_ATL,
  objectivesMYP: ELEMENT_TYPE_MYP_OBJECTIVES,
  conceptsMYP: ELEMENT_TYPE_MYP_KEY_CONCEPT,
  globalContextMYP: PLANNER_ELEMENT_MYP_GLOBAL_CONTEXT,
  lpMYP: ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  focusAreasMYP: ELEMENT_TYPE_MYP_FOCUS_AREA,
  benchmarks: ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  action: ELEMENT_TYPE_PYP_ACTION,
  atls: ELEMENT_TYPE_PYP_ATL,
  concepts: ELEMENT_TYPE_PYP_KEY_CONCEPT,
  lp: ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  subjectStandardDP: ELEMENT_TYPE_DP_SUBJECT_STANDARD,
};

export const pypElementLabelMapping = {
  lp: "Learner Profile Attributes",
  action: "Action",
  concepts: "Concepts",
  theme: "Themes",
  atls: "Approaches to Learning",
  benchmarks: "Knowledge",
  atlsUBD: "UBD Skills",
  learningStandardUBD: "Subject Standards",
  learningStandardMYP: "Subject Standards",
};

export const pypElementSetMapping = {
  lp: "learnerProfiles",
  action: "actions",
  concepts: "concepts",
  theme: "themes",
  atls: "atls",
  benchmarks: "benchmarks",
  subjects: "subjects",
  relatedConcepts: "relatedConcepts",
  subjectGroup: "subjectGroups",
  learningStandardUBD: "learningStandardUBD",
  atlsUBD: "atlsUBD",
  atlsMYP: "atlsMYP",
  learningStandardMYP: "learningStandardMYP",
  pypNestedElement: "nodes",
};
